module.exports = __webpack_public_path__ + "img/01logo-tee2021.bd5f3ac0.png";